import { Component } from '@angular/core';

@Component({
  selector: 'ui-title',
  templateUrl: './title.component.html'
})
export class TitleComponent {
}
